/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Sex_RequiredInputs */

const en_us2_body_assessment_sex_required = /** @type {(inputs: Body_Assessment_Sex_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The calculation needs to know which term to use. Pick female or male for this estimate.`)
};

const pt_br2_body_assessment_sex_required = /** @type {(inputs: Body_Assessment_Sex_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O cálculo precisa saber qual termo usar. Escolha entre feminino e masculino para esta estimativa.`)
};

const es_419_body_assessment_sex_required = /** @type {(inputs: Body_Assessment_Sex_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El cálculo necesita saber qué término usar. Elige femenino o masculino para esta estimación.`)
};

const pt_pt2_body_assessment_sex_required = /** @type {(inputs: Body_Assessment_Sex_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O cálculo precisa de saber que termo usar. Escolhe entre feminino e masculino para esta estimativa.`)
};

const fr_fr2_body_assessment_sex_required = /** @type {(inputs: Body_Assessment_Sex_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le calcul doit savoir quel terme utiliser. Choisis féminin ou masculin pour cette estimation.`)
};

const de_de2_body_assessment_sex_required = /** @type {(inputs: Body_Assessment_Sex_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Berechnung muss wissen, welcher Begriff gilt. Wähle für diese Schätzung weiblich oder männlich.`)
};

const it_it2_body_assessment_sex_required = /** @type {(inputs: Body_Assessment_Sex_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il calcolo deve sapere quale termine usare. Scegli femminile o maschile per questa stima.`)
};

/**
* | output |
* | --- |
* | "The calculation needs to know which term to use. Pick female or male for this estimate." |
*
* @param {Body_Assessment_Sex_RequiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_sex_required = /** @type {((inputs?: Body_Assessment_Sex_RequiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Sex_RequiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_sex_required(inputs)
	if (locale === "es-419") return es_419_body_assessment_sex_required(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_sex_required(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_sex_required(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_sex_required(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_sex_required(inputs)
	return en_us2_body_assessment_sex_required(inputs)
});
export { body_assessment_sex_required as "body_assessment.sex_required" }